export default __webpack_public_path__ + "static/media/Q14_1_resized.90fba43b.jpg";